import { useEffect, useState, type ReactElement } from 'react';
import { MASTER_API_URL } from '../../constants';
import { activityFromAudit, type ActivityRow } from '../../domain/activityLog';
import { ActivityTable } from './ActivityTable';

type AuthFetch = (url: string, init?: RequestInit) => Promise<Response>;

export function EntityActivitySection({
  authFetch,
  path,
  testId
}: {
  authFetch: AuthFetch;
  path: string;
  testId?: string;
}): ReactElement {
  const [rows, setRows] = useState<ActivityRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      setLoading(true);
      try {
        const res = await authFetch(`${MASTER_API_URL}${path}`);
        if (!res.ok) {
          if (!cancelled) {
            setRows([]);
          }
          return;
        }
        const body = (await res.json()) as { items?: unknown };
        const items = Array.isArray(body.items) ? body.items : [];
        if (!cancelled) {
          setRows(
            items
              .filter((row): row is Parameters<typeof activityFromAudit>[0] => {
                return Boolean(row && typeof row === 'object' && 'action' in row && 'id' in row);
              })
              .map(activityFromAudit)
          );
        }
      } catch {
        if (!cancelled) {
          setRows([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [authFetch, path]);

  return <ActivityTable rows={rows} loading={loading} testId={testId} />;
}
